import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import CategoryList from "@/components/feature/CategoryList";

export default function HotPage() {
  return (
    <>
      <Navbar />
      <main>
        <CategoryList category="hot" />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}